<template>
    <div class="drawer">
        <el-form label-width="80px">
            <el-form-item label="结算方式" style="display: block">
                <el-select placeholder="请选择结算方式"
                           size="small"
                           filterable
                           v-model="order.custSettle"
                           :disabled="disabled">
                    <el-option :key="i"
                               :label="item"
                               :value="item"
                               v-for="(item, i) in custSettleName"
                               @click.native ="custSettleSelect(i)"/>
                </el-select>
            </el-form-item>
            <!-- <el-form-item label="备注信息" style="display: block">
                <el-input :rows="8" type="textarea" v-model="order.remarks" style="width: 230px"/>
            </el-form-item > -->
            <el-form-item label="账期" style="display: block">
                <div v-for="(plan,i) in settlePlan" :key="i" style="margin-bottom:8px;">
                    <el-autocomplete
                            class="input-with-select"
                            size='small'
                            v-model="plan.percent"
                            style="width:330px;display:inline-block;"
                            :disabled="disabled"
                            @change="changePercent(plan)"
                            :fetch-suggestions="querySearchPercent">
                        <template slot="prepend">
                            <el-select v-model="plan.ways"
                                       size='small'
                                       style="width:100px;"
                                       placeholder="请选账期"
                                       @change="wayChange(i)"
                                       :disabled="disabled">
                                <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                            <el-select v-model="plan.way"
                                       size='small'
                                       style="width:100px; padding-left: 35px"
                                       placeholder="请选账期"
                                       v-if="plan.ways === '欠款'"
                                       :disabled="disabled">
                                <el-option
                                    v-for="item in wayOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </template>
                        <template slot="append">%</template>
                    </el-autocomplete>
                    <div v-if="plan.way === '月结'" style="display:inline-block;">
                        <el-autocomplete
                            style="width:120px;"
                            class="month"
                            size='small'
                            v-model="plan.month"
                            :disabled="disabled"
                            @change="changeMonth(plan)"
                            :fetch-suggestions="querySearchMonth">
                            <template slot="append">月</template>
                        </el-autocomplete>
                        <!-- <el-input
                            style="width:100px;margin-left:5px"
                            size='small'
                            v-model="plan.day"
                            :disabled="disabled">
                            <template slot="append">号</template>
                        </el-input> -->
                    </div>
                    <div v-if="plan.way === '日结'" style="display:inline-block;">
                        <el-input
                            style="width:120px;"
                            size='small'
                            v-model="plan.day"
                            :disabled="disabled">
                            <template slot="append">天</template>
                        </el-input>
                    </div>
                    <i  class="el-icon-error"
                        style="margin-left:5px;font-size:20px;"
                        v-if="settlePlan.length >1 && !disabled"
                        @click="del(i)"
                        />
                </div>
                <div style="text-align:center;width:330px">
                    <i class="el-icon-circle-plus"
                        style="font-size:30px;"
                        v-if="!disabled"
                        @click="add"/>
                </div>
            </el-form-item>
            <!-- <el-form-item label="截止日期" style="display: block">
                <el-date-picker
                    v-model="expiryDates"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期"
                    :disabled="disabled">
                </el-date-picker>
            </el-form-item> -->
        </el-form>
    </div>
</template>

<script>
    export default {
        name: 'Settlement.vue',
        props: {
            // expiryDate: {
            //     type: String,
            //     default() {
            //         return '';
            //     }
            // },
            settleName: {
                type: String,
                default() {
                    return '';
                }
            },
            settlePlans: {
                type: Array,
                default() {
                    return [];
                }
            },
            disabled: {
                type: Boolean,
                default() {
                    return false;
                }
            }
        },
        data() {
            return {
                order: {
                    id: '',
                    custSettle: '',
                    remarks: ''
                },
                options: [{
                    value: '定金',
                    label: '定金'
                    }, {
                    value: '现款',
                    label: '现款'
                    }, {
                    value: '欠款',
                    label: '欠款'
                }],
                wayOptions: [{
                    value: '月结',
                    label: '月结'
                    }, {
                    value: '日结',
                    label: '日结'
                }],
                settlePlan: [
                    {
                        ways: '',
                        way: '',
                        month: '0',
                        day: 0,
                        percent: '0'
                    }
                ],
                expiryDates: '',
                custSettleName: [],
                settleList: [],
                defaultSettlePlan: [{
                    ways: '',
                    way: '',
                    month: '0',
                    day: 0,
                    percent: '0'
                }],
                month: [{
                    value: '0'
                }, {
                    value: '1'
                }, {
                    value: '2'
                }, {
                    value: '3'
                }, {
                    value: '4'
                }, {
                    value: '5'
                }, {
                    value: '6'
                }, {
                    value: '7'
                }, {
                    value: '8'
                }, {
                    value: '9'
                }, {
                    value: '10'
                }, {
                    value: '11'
                }, {
                    value: '12'
                }],
                percent: [{
                    value: '10'
                }, {
                    value: '20'
                }, {
                    value: '30'
                }, {
                    value: '40'
                }, {
                    value: '50'
                }, {
                    value: '60'
                }, {
                    value: '70'
                }, {
                    value: '80'
                }, {
                    value: '90'
                }, {
                    value: '100'
                }]
            };
        },
        watch: {
            // expiryDate() {
            //     if (this.expiryDate) {
            //         this.expiryDates = this.expiryDate;
            //     }
            // },
            settleName() {
                if (this.settleName) {
                    this.order.custSettle = this.settleName;
                }
            },
            settlePlans() {
                if (this.settlePlans) {
                    this.settlePlan = this.settlePlans;
                    const settlePlansCopy = JSON.parse(JSON.stringify(this.settlePlans));
                    settlePlansCopy.forEach(item => {
                        if (item.ways) {
                            delete item.ways;
                        }
                        if (item.percent) {
                            item.percent = Number(item.percent);
                        }
                        if (item.month) {
                            item.month = Number(item.month);
                        }
                    });
                    this.settlePlan.forEach(item => {
                        if (item.way === '定金' || item.way === '现款' || item.way === '') {
                            item.ways = item.way;
                        } else {
                            item.ways = '欠款';
                        }
                        item.month = item.month.toString();
                        item.percent = item.percent.toString();
                    });
                    if (this.settlePlans.length !== 0) {
                        this.defaultSettlePlan = JSON.parse(JSON.stringify(this.settlePlan));
                    }
                    const settlePlansList = this.settleList.map(item => item.settlePlan);
                    if (JSON.stringify(settlePlansList).indexOf(JSON.stringify(settlePlansCopy)) === -1) {
                        this.order.custSettle = '自定义';
                    } else {
                        const i = this.settleList.findIndex(item => {
                            return JSON.stringify(item.settlePlan) === JSON.stringify(settlePlansCopy);
                        });
                        this.order.custSettle = this.settleList[i].custSettle;
                    }
                }
            },
            settlePlan: {
                handler(newValue, oldValue) {
                    if (JSON.stringify(this.settlePlan) !== JSON.stringify(this.defaultSettlePlan)) {
                        this.order.custSettle = '自定义';
                    }
                },
                deep: true
            }
        },
        created() {
            this.getSettle();
        },
        methods: {
            changePercent(plan) {
                plan.month = '';
            },
            querySearchPercent(queryString, cb) {
                cb(this.percent);
            },
            changeMonth(plan) {
                plan.month = '';
            },
            querySearchMonth(queryString, cb) {
                cb(this.month);
            },
            async getSettle() {
                const { data } = await this.qGet('/customer/settle');
                if (data && data.length > 0) {
                    this.settleList = data;
                    this.custSettleName = data.map(i => i.custSettle);
                }
            },
            custSettleSelect(index) {
                this.settlePlan = JSON.parse(JSON.stringify(this.settleList[index].settlePlan));
                this.settlePlan.forEach(item => {
                    if (item.way === '定金' || item.way === '现款') {
                        item.ways = item.way;
                    } else {
                        item.ways = '欠款';
                    }
                    item.month = item.month.toString();
                    item.percent = item.percent.toString();
                });
                this.defaultSettlePlan = JSON.parse(JSON.stringify(this.settlePlan));
                this.$emit('setDefaultSettlePlan', this.settlePlan);
            },
            wayChange(i) {
                this.settlePlan[i].month = '0';
                this.settlePlan[i].day = 0;
                this.settlePlan[i].percent = '0';
                if (this.settlePlan[i].ways !== '欠款') {
                    this.settlePlan[i].way = this.settlePlan[i].ways;
                } else {
                    this.settlePlan[i].way = '';
                }
            },
            add() {
                this.settlePlan.push({
                        ways: '',
                        way: '',
                        month: '0',
                        day: 0,
                        percent: '0'
                });
            },
            del(i) {
                this.settlePlan.splice(i, 1);
            }
        }
    };
</script>

<style lang="scss" scoped>
.input-with-select .el-input-group__prepend {
    background-color: #fff;
}
.el-form-item {
    padding-top: 10px;
    ::v-deep.el-form-item__label {
        width: 80px !important;
    }
}
::v-deep.input-with-select {
    .el-input {
        width: 100% !important;
    }
}
::v-deep.month {
    .el-input {
        width: 100% !important;
    }
}
</style>
